import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, HostBinding, inject, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { BrowserSnifferService } from '../../../services/browser-sniffer.service';
import { TraceService } from '../../../services/trace.service';
import { TraceViewComponent } from '../trace-view/trace-view.component';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TraceImportComponent } from '../trace-import/trace-import.component';
import { BOTTOM_PANE_DATA, BOTTOM_PANE_STATE } from 'projects/tfv/src/app/shared/ui/bottom-pane/bottom-pane.tokens';
import { Subscription } from 'rxjs';
import { BottomPaneRef } from 'projects/tfv/src/app/shared/ui/bottom-pane/bottom-pane.ref';
import { BackEventService } from '@tt-lib/services/back-event.service';
import { ToggleEventNameType, ToggleEventService, ToggleEventType } from '@tt-lib/services/toggle-event.service';

@Component({
  selector: 'tt-trace-xsmall-dialog-view',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    A11yModule,
    TraceViewComponent
  ],
  templateUrl: './trace-xsmall-dialog-view.component.html',
  standalone: true
})
export class TraceXsmallDialogViewComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  //private readonly paneRef = inject(BottomPaneRef);
  // @HostBinding('style') style = 'position:relative';
  @ViewChild('traceView') public traceView: TraceViewComponent;

  private data = inject<any>(BOTTOM_PANE_DATA);
  private bottomPaneState = inject<any>(BOTTOM_PANE_STATE);
  private backEventSubscription: Subscription = null;

  private _hideTraceCreate: boolean = false;

  constructor(
    public traceService: TraceService,
    public translateService: TranslateService,
    private _cdr: ChangeDetectorRef,
    public dialogRef: BottomPaneRef<TraceXsmallDialogViewComponent>,
    public browserSniffer: BrowserSnifferService,
    private backEventService: BackEventService,
    private toggleEventService: ToggleEventService
  ) {
    this._hideTraceCreate = this.data && typeof this.data.hideTraceCreate === 'boolean' ? this.data.hideTraceCreate : false;
  }

  ngOnInit(): void {
    this.backEventSubscription = this.toggleEventService.emitter$.subscribe(
      (toggleEvent: ToggleEventType) => {
        if (toggleEvent.forwardedFor === 'TraceXsmallDialogViewComponent' && toggleEvent.eventName === ToggleEventNameType.CLOSE_COMMAND) {
          this.dialogRef.closeClick();
        }
      }
    );
    this.backEventService.registerOpenedWindow({ windowName: 'TraceXsmallDialogViewComponent', isAutoCloseableWindow: false });
  }

  ngOnDestroy(): void {
    this.backEventSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dialogRef.title.set(this.translateService.instant('trace.view-route.title'));
    this.dialogRef.subTitle.set(
      this.traceView.isActive() && this.traceView.ref_traceRouteData().metadata.name ?
        this.traceView.ref_traceRouteData().metadata.name.length > 100 ?
          (this.traceView.ref_traceRouteData().metadata.name.slice(0, 100) + '...') :
          this.traceView.ref_traceRouteData().metadata.name :
        this.translateService.instant('trace.view-route.routewithnoname')
    );
    //readon
    if (this.data) { this.traceView._scrollToInfo(this.data) };
  }

  // ngOnInit(): void {
  // }
  //to avoid ExpressionChangedAfterItHasBeenCheckedError
  ngAfterViewChecked() {
    this._cdr.detectChanges();
  }

  /*
  @Input()
  set hideTraceCreate(val: string) {
    this._hideTraceCreate = val ? val.trim().toLowerCase() === "true" : false;
  }
  */

  get hideTraceCreate(): boolean {
    return this._hideTraceCreate;
  }
}
